import ApiRoutes from "api/apiRoutes";
import { exeRequest } from "../http/requestConfig";

export default class IdentityCardService {
    
    getAll(sCallBack, eCallBack) {
        exeRequest(ApiRoutes.identityCardResource, {}, sCallBack, eCallBack)
    }
}